<script setup lang="ts">
import { useServiceMedia } from "@/composables/useServiceMedia";

const props = defineProps({
  service: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "",
  },
});

const { serviceIcon } = useServiceMedia(props.service);
</script>

<template>
  <span
    class="material-symbols-outlined"
    :class="[!disabled ? 'cursor-not-allowed pointer-events-none' : '', size]"
    >{{ serviceIcon }}</span
  >
</template>
